import { env } from '../../environments/environment'

const apiUrl = {
    baseUrl: env.REACT_APP_API_URL,
    projects: {
        tempoProjectsList: {
            uri: 'tempo/projects',
            type: 'post',
        },
        tempoProject: {
            uri: 'tempo/projects/:projectId',
            type: 'get',
        },
        patchTempoProject: {
            uri: 'tempo/projects/:projectId',
            type: 'patch',
        },
        tempoQuestions: {
            uri: 'tempo/projects/:projectId/feedbackQuestions',
            type: 'get',
        },
        tempoAnswers: {
            uri: 'tempo/projects/:projectId/feedbackAnswers',
            type: 'post',
        },
        memsourceProjectsList: {
            uri: 'memsource/projects',
            type: 'post',
        },
        memsourceProjectsListCsv: {
            uri: 'memsource/projects/csv',
            type: 'get',
        },
        memsourceValidatorNames: {
            uri: 'memsource/projects/validator-names',
            type: 'get',
        },
        memsourceProject: {
            uri: 'memsource/projects/:uid',
            type: 'get',
        },
        memsourceWorkflowStatus: {
            uri: 'memsource/projects/workflow-status',
            type: 'get',
        },
        memsourceQuoteAccept: {
            uri: 'memsource/projects/quote-accept',
            type: 'put',
        },
        memsourceProjectCancel: {
            uri: 'memsource/projects/project-cancel',
            type: 'put',
        },
        memsourceRefreshProject: {
            uri: 'memsource/projects/refresh-project',
            type: 'post',
        },
        xtrfProjectsList: {
            uri: 'xtrf/projects/list',
            type: 'post',
        },
        xtrfProjectTasks: {
            uri: 'xtrf/projects/:projectId/tasks',
            type: 'get',
        },
        xtrfProject: {
            uri: 'xtrf/projects/:projectId',
            type: 'get',
        },
        xtrfProjectFiles: {
            uri: 'xtrf/projects/:projectId/files',
            type: 'get',
        },
        xtrfProjectFeedbackAnswers: {
            uri: 'xtrf/projects/:projectId/feedback',
            type: 'get',
        },
        xtrfProjectsPostFeedbackAnswers: {
            uri: 'xtrf/projects/:projectId/feedback',
            type: 'post',
        },
        xtrfPostFile: {
            uri: 'xtrf/projects/files',
            type: 'post',
        },
        xtrfFeedbackQuestion: {
            uri: 'xtrf/system/customer-feedback-questions/:locale',
            type: 'get',
        },
        xtrfProjectdownloadPdf: {
            uri: 'xtrf/projects/:projectId/confirmation',
            type: 'get',
            config: {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
            },
        },
        xtrfProjectFile: {
            uri: 'xtrf/projects/files/:fileId',
            type: 'get',
            config: {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
            },
        },
    },
    jobs: {
        memsourceJobsList: {
            uri: 'memsource/jobs',
            type: 'post',
        },
        memsourceJobsListCsv: {
            uri: 'memsource/jobs/csv',
            type: 'get',
        },
    },
    terminology: {
        list: {
            uri: 'tempo/terminology/list',
            type: 'get',
        },
    },
    quotes: {
        xtrfQuotes: {
            uri: 'xtrf/quotes/list',
            type: 'post',
        },
        xtrfNewQuote: {
            uri: 'xtrf/quotes/new',
            type: 'post',
        },
        xtrfQuote: {
            uri: 'xtrf/quotes/:quoteId',
            type: 'get',
        },
        xtrfAcceptQuote: {
            uri: 'xtrf/quotes/:quoteId/acceptance',
            type: 'put',
        },
        xtrfDeclineQuote: {
            uri: 'xtrf/quotes/:quoteId/decline',
            type: 'delete',
        },
        tempoAcceptQuote: {
            uri: 'tempo/projects/:quoteId/acceptance',
            type: 'put',
        },
        tempoDeclineQuote: {
            uri: 'tempo/projects/:quoteId/decline',
            type: 'put',
        },
        xtrfQuotedownloadPdf: {
            uri: 'xtrf/quotes/:quoteId/confirmation',
            type: 'get',
            config: {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
            },
        },
        xtrfQuoteTasks: {
            uri: 'xtrf/quotes/:quoteId/tasks',
            type: 'get',
        },
        xtrfQuoteFiles: {
            uri: 'xtrf/quotes/:quoteId/files',
            type: 'get',
        },
        tempoQuotes: {
            uri: 'tempo/quotes',
            type: 'post',
        },
        tempoNewQuote: {
            uri: 'tempo/quotes/create',
            type: 'post',
        },
        tempoQuote: {
            uri: 'tempo/quotes/:id',
            type: 'get',
        },
        tempoUpdateQuote: {
            uri: 'tempo/quotes/:id/update',
            type: 'put',
        },
        tempoDeleteQuote: {
            uri: 'tempo/quotes/:id/delete',
            type: 'delete',
        },
    },
    reports: {
        xtrfReportsAll: {
            uri: 'xtrf/reports/all',
            type: 'get',
        },
        xtrfReportsCsv: {
            uri: 'xtrf/reports/csv/:reportId',
            type: 'get',
        },
    },
    jira: {
        messagesQuote: {
            uri: 'xtrf/jira/quote/:id',
            type: 'get',
        },
        messagesProject: {
            uri: 'xtrf/jira/project/:id',
            type: 'get',
        },
        addMessagesQuote: {
            uri: 'xtrf/jira/add/comment/quote/:id',
            type: 'post',
        },
        addMessagesProject: {
            uri: 'xtrf/jira/add/comment/project/:id',
            type: 'post',
        },
    },
    languages: {
        memsourceLanguagesList: {
            uri: 'memsource/supported-language',
            type: 'get',
        },
        xtrfLanguagesList: {
            uri: 'xtrf/system/languages',
            type: 'get',
        },
        tempoLanguagesList: {
            uri: 'tempo/languages',
            type: 'get',
        },
        tempoTerminologyLanguagesList: {
            uri: 'tempo/terminology/languages',
            type: 'get',
        },
    },
    specializations: {
        xtrfSpecializationsList: {
            uri: 'xtrf/system/specializations',
            type: 'get',
        },
    },
    services: {
        xtrfServicesList: {
            uri: 'xtrf/system/services',
            type: 'get',
        },
        tempoServicesList: {
            uri: 'tempo/services',
            type: 'get',
        },
    },
    system: {
        xtrfSession: {
            uri: 'xtrf/system/session',
            type: 'get',
        },
    },
    declineReason: {
        tempoDeclineReason: {
            uri: 'tempo/declineReason',
            type: 'get',
        },
    },
    collections: {
        tempoCollections: {
            uri: 'tempo/terminology/collections',
            type: 'get',
        },
    },
    validation: {
        tempoList: {
            uri: 'tempo/validation/list',
            type: 'get',
        },
        tempoValidators: {
            uri: 'tempo/validation/validators',
            type: 'get',
        },
        tempoStatus: {
            uri: 'tempo/validation/status',
            type: 'get',
        },
        tempoResponsibles: {
            uri: 'tempo/validation/responsibles',
            type: 'get',
        },
    },
    costCenters: {
        tempoCostCentersList: {
            uri: 'tempo/costCenters',
            type: 'get',
        },
    },
    customers: {
        tempoCustomersList: {
            uri: 'tempo/customers',
            type: 'get',
        },
    },
    customerEntities: {
        tempoCustomerEntitiesList: {
            uri: 'tempo/customerForEntities',
            type: 'get',
        },
    },
    documentTypes: {
        tempoDocumentTypesList: {
            uri: 'tempo/documentTypes',
            type: 'get',
        },
    },
    requestingEntities: {
        tempoRequestingEntitiesList: {
            uri: 'tempo/requestingEntities',
            type: 'get',
        },
    },
    requestTypes: {
        tempoRequestTypesList: {
            uri: 'tempo/requestTypes',
            type: 'get',
        },
    },
    auth: {
        login: {
            uri: 'auth/login',
            type: 'post',
        },
        whoAmI: {
            uri: 'memsource/whoAmI',
            type: 'get',
        },
        checkEmail: {
            tempoCheckEmail: {
                uri: 'tempo/checkEmail',
                type: 'post',
            },
        },
        sendResetPasswordEmail: {
            tempoSendResetPasswordEmail: {
                uri: 'tempo/sendResetPasswordEmail',
                type: 'post',
            },
        },
        resetPassword: {
            tempoResetPassword: {
                uri: 'tempo/resetPassword',
                type: 'put',
            },
        },
    },
    common: {
        sendMessage: {
            uri: 'contact/message',
            type: 'post',
        },
    },
}

export default apiUrl
